module.exports = __webpack_public_path__ + "media/images/version_merge/facebook_icon-a224c6d6f3048611a412fa23baf24f70.png";